"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _formSelect = _interopRequireDefault(require("./form-select"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("..");
var _reactIntl = require("react-intl");
class FinishPostDonation extends _react.default.Component {
  constructor(p) {
    super(p);
    this.state = {
      value: this.props.defaultSelectedValue,
      success: false
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    const value = e.currentTarget.value;
    this.setState({
      value: Number(value)
    });
  }
  render() {
    const _this$props = this.props,
      mobilization = _this$props.mobilization,
      widget = _this$props.widget,
      donationCustomerData = _this$props.donationCustomerData,
      defaultSelectedValue = _this$props.defaultSelectedValue,
      onClickDonation = _this$props.onClickDonation,
      FinishDonationComponent = _this$props.finishDonationComponent,
      imageUrl = _this$props.imageUrl;
    return this.state.success ? /*#__PURE__*/_react.default.createElement(_.TellAFriend, (0, _extends2.default)({}, this.props, {
      mobilization: mobilization,
      widget: widget,
      message: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: this.state.donationValue ? 'widgets.components--donation.finish-post-donation-messages.donation-ok' : 'widgets.components--donation.finish-post-donation-messages.not-now'
      }),
      imageUrl: this.state.donationValue && imageUrl
    })) : /*#__PURE__*/_react.default.createElement(_formSelect.default, {
      mobilization: mobilization,
      widget: widget,
      onChange: this.handleChange,
      value: this.state.value,
      onSubmit: async value => {
        await onClickDonation(value);
        this.setState({
          success: true,
          donationValue: value
        });
      }
    });
  }
}
var _default = exports.default = FinishPostDonation;